import { WorkspaceList } from '@/Workspaces/WorkspaceList'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/workspace/')({
  component: RouteComponent,
})

function RouteComponent() {
  return <WorkspaceList />
}
